export default __webpack_public_path__ + "static/media/face-vomiting_1f92e.387b86f8.png";